export default "__VITE_ASSET__MVeKdZX0__"